export default [
    {
        path: "/report-detailed",
        name: "report detailed",
        component: () => import("@/views/Reports/DetailedReport.vue"),
        meta: {
            resource: "credit",
            pageTitle: "Detailed Report",
            breadcrumb: [
                {
                    text: "Detailed Report",
                    active: true
                }
            ]
        }
    },
    {
        path: "/report/product-costs",
        name: "report product-costs",
        component: () => import("@/views/Reports/DetailedReport.vue"),
        meta: {
            action: "report detailed",
            resource: "credit",
            pageTitle: "Report",
            breadcrumb: [
                {
                    text: "Report",
                    active: true
                }
            ]
        }
    },
    {
        path: "/report/commissions",
        name: "report commissions",
        component: () => import("@/views/Reports/DetailedReport.vue"),
        meta: {
            action: "report detailed",
            resource: "credit",
            pageTitle: "Report",
            breadcrumb: [
                {
                    text: "Report",
                    active: true
                }
            ]
        }
    },
    {
        path: "/report/transaction",
        name: "report transaction",
        component: () => import("@/views/Reports/DetailedReport.vue"),
        meta: {
            action: "report detailed",
            resource: "credit",
            pageTitle: "Report",
            breadcrumb: [
                {
                    text: "Report",
                    active: true
                }
            ]
        }
    },
    {
        path: "/report/activation-rates",
        name: "report activation",
        component: () => import("@/views/Reports/DetailedReport.vue"),
        meta: {
            action: "report detailed",
            resource: "credit",
            pageTitle: "Report",
            breadcrumb: [
                {
                    text: "Report",
                    active: true
                }
            ]
        }
    },
    {
        path: "/report/country-stats",
        name: "report country",
        component: () => import("@/views/Reports/DetailedReport.vue"),
        meta: {
            action: "report detailed",
            resource: "credit",
            pageTitle: "Report",
            breadcrumb: [
                {
                    text: "Report",
                    active: true
                }
            ]
        }
    },
    {
        path: "/report/invoice",
        name: "report invoice",
        component: () => import("@/views/Reports/DetailedReport.vue"),
        meta: {
            action: "report detailed",
            resource: "credit",
            pageTitle: "Report",
            breadcrumb: [
                {
                    text: "Report",
                    active: true
                }
            ]
        }
    }
];
